// extracted by mini-css-extract-plugin
export default {"page-title":"profile_page-title__4V7QM"};